import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { memo, useEffect, useRef, useState } from 'react';
import { bool, func, node, number } from 'prop-types';
import classNames from 'classnames/bind';
import { isString } from '@s7/ui-kit/utils/type';
import ChevronNormalLeft from '@s7/ui-kit/icons/ChevronNormalLeft';
import ChevronSmallLeft from '@s7/ui-kit/icons/ChevronSmallLeft';
import CloseLinear from '@s7/ui-kit/icons/CloseLinear';
import { Modal, Text, Title } from '@s7/ui-kit';
import styles from './ModalAuthorization.css';
import { useIsFirstRender } from '../hooks/useIfFirstRender';
var cx = classNames.bind(styles);

var setTop = function setTop(el, value) {
  el.setAttribute('style', "top: ".concat(value, "px;"));
};

var ModalAuthorization = function ModalAuthorization(_ref) {
  var isDesktop = _ref.isDesktop,
      children = _ref.children,
      backTitle = _ref.backTitle,
      isModal = _ref.isModal,
      isOpen = _ref.isOpen,
      onBack = _ref.onBack,
      onClose = _ref.onClose,
      title = _ref.title,
      hasPopup = _ref.hasPopup,
      wrapTitle = _ref.wrapTitle,
      titleSize = _ref.titleSize,
      getTestId = _ref.getTestId;

  var _useState = useState(!isOpen),
      _useState2 = _slicedToArray(_useState, 2),
      hidden = _useState2[0],
      setHidden = _useState2[1];

  var ref = useRef();
  var isFirst = useIsFirstRender();
  useEffect(function () {
    if (isDesktop || !isModal) {
      setHidden(!isOpen);
    } else if (ref && ref.current) {
      if (isFirst) {
        setTop(ref.current, window.innerHeight);
      }

      if (isOpen) {
        setHidden(false);
        setTimeout(function () {
          setTop(ref.current, 24);
        }, 210);
      } else {
        setTimeout(function () {
          setHidden(true);
        }, 210);
      }
    }
  }, [isDesktop, isModal, isOpen]);

  var handleClose = function handleClose() {
    onClose();
  };

  var isText = isDesktop && isString(children);
  var isMobileModalIsOpen = !isDesktop && isModal;
  var isShowModalTitle = isDesktop && !isMobileModalIsOpen;
  var TitleComponent = /*#__PURE__*/React.createElement(React.Fragment, null, onBack && /*#__PURE__*/React.createElement("div", {
    className: cx('BackTitle')
  }, /*#__PURE__*/React.createElement("button", _extends({
    className: cx('BackButton'),
    onClick: onBack,
    type: "button"
  }, getTestId('backToLogin')), /*#__PURE__*/React.createElement("span", {
    className: cx('BackIcon')
  }, /*#__PURE__*/React.createElement(ChevronSmallLeft, null)), /*#__PURE__*/React.createElement(Text, {
    as: "span",
    color: "N300",
    weight: "semibold"
  }, backTitle))), isShowModalTitle && /*#__PURE__*/React.createElement("div", {
    className: cx('Top')
  }, /*#__PURE__*/React.createElement(Title, _extends({
    level: titleSize,
    size: "small",
    style: {
      fontWeight: 600
    }
  }, getTestId('title')), title)));
  var Component = isModal ? Modal : 'div';
  var componentProps = isModal ? {
    contentComponent: !isText && children,
    onClose: handleClose,
    size: 'medium',
    title: TitleComponent,
    wrapTitle: wrapTitle,
    withScroll: false,
    width: 360,
    classes: {
      root: cx('component_modal'),
      title: cx('display_block'),
      inner: cx('display_block')
    }
  } : {};
  return /*#__PURE__*/React.createElement("div", {
    className: cx('root', {
      hidden: hidden,
      isModal: isModal
    })
  }, isDesktop ? /*#__PURE__*/React.createElement("div", _extends({
    className: cx('Modal', {
      has_popup: hasPopup
    }),
    key: 0
  }, getTestId('popup')), /*#__PURE__*/React.createElement(Component, componentProps, isModal || TitleComponent, (!isModal || isText) && children)) : /*#__PURE__*/React.createElement("div", _extends({
    className: cx('Popup'),
    key: 1,
    ref: ref
  }, getTestId('popup')), (onBack || title || onClose) && /*#__PURE__*/React.createElement("div", {
    className: cx('Header')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('Title')
  }, onBack && /*#__PURE__*/React.createElement("button", {
    className: cx('Button', 'Back'),
    onClick: onBack,
    type: "button"
  }, /*#__PURE__*/React.createElement(ChevronNormalLeft, null)), /*#__PURE__*/React.createElement(Title, _extends({
    level: 5,
    size: "small"
  }, getTestId('title')), title)), onClose && /*#__PURE__*/React.createElement("button", {
    className: cx('Button', 'Close'),
    onClick: onClose,
    type: "button"
  }, /*#__PURE__*/React.createElement(CloseLinear, null))), /*#__PURE__*/React.createElement("div", {
    className: cx('Content', {
      has_popup: hasPopup
    })
  }, children)), /*#__PURE__*/React.createElement("div", {
    className: cx('Overlay'),
    onClick: onClose,
    role: "button"
  }));
};

ModalAuthorization.propTypes = {
  isDesktop: bool,
  backTitle: node,
  children: node,
  isModal: bool,
  isOpen: bool,
  onBack: func,
  onClose: func,
  title: node,
  hasPopup: bool,
  wrapTitle: bool,
  titleSize: number,
  getTestId: func
};
ModalAuthorization.defaultProps = {
  isModal: true,
  wrapTitle: false,
  titleSize: 2
};
export default /*#__PURE__*/memo(ModalAuthorization);